<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText :field="fields?.title" class="services-overview-title" tag="h2" />
      <div class="services-overview-text">
        <JssRichText :field="fields?.desclt" class="services-overview-text-lt" />
        <JssRichText :field="fields?.descrt" class="services-overview-text-rt" />
      </div>
      <AdaptiveImage class="services-overview-image" :field="fields?.image" :isBackground="false" />
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ServicesOverview',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'services-overview'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.services-overview {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    font-weight: 700;
    color: $black;
    text-align: center;
  }

  &-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    margin-top: 24px;

    &-lt {
      font-size: 16px;
      line-height: 1.4;
      color: #404040;
    }

    &-rt {
      font-size: 16px;
      line-height: 1.4;
      color: #404040;
    }
  }

  &-image {
    margin-top: 24px;
    width: 100%;
    aspect-ratio: 1200 / 454;
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-text {
      flex-direction: row;
      align-items: flex-start;
      gap: 68px;
      margin-top: 40px;
    }

    &-image {
      margin-top: 40px;
    }
  }
}
</style>
